import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { DeleteIconComponent } from '@kuiper/icons';

@Component({
  selector: 'lib-remove-super-manager',
  imports: [TranslocoPipe, DeleteIconComponent],
  templateUrl: './remove-super-manager.component.html',
  styleUrl: './remove-super-manager.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class RemoveSuperManagerComponent {
  isRemoveAdminLoading = input<boolean>(false);

  removeAdmin = output<void>();
  closeModal = output<void>();
}
